import React from 'react'
import { BrandSliderProps } from './types'
import styles from './BrandSlider.module.scss'

export const StyledBrandSlider: React.FC<BrandSliderProps> = props => {
  const images = props.logos.map(logo => (
    <img className="inline px-L" key={logo.src} src={logo.src} alt={logo.alt} width={logo.width} loading="lazy" />
  ))

  return (
    <div className={`flex items-center w-max h-16 ${styles.container}`}>
      <div>{images}</div>
      <div>{images}</div>
    </div>
  )
}
